module.exports = __webpack_public_path__ + "img/konkat.7a5d4b78.png";